module.exports = __webpack_public_path__ + "static/img/6.484659a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/zh/6.png
// module id = dnFR
// module chunks = 0